var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCdSerIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2938_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7757 19.2773L43.2761 18.5774C42.8911 17.3012 42.3808 16.069 41.7522 14.8971L43.7316 11.9281C44.1035 11.3703 44.03 10.6276 43.5559 10.1537L38.2526 4.85038C37.7786 4.37637 37.0359 4.30288 36.4782 4.67459L33.5091 6.65394C32.3373 6.02544 31.105 5.51525 29.8287 5.13013L29.1289 1.63044C28.9975 0.973156 28.4203 0.5 27.75 0.5H20.25C19.5797 0.5 19.0025 0.973156 18.871 1.63044L18.1712 5.13013C16.8949 5.51525 15.6626 6.02553 14.4908 6.65394L11.5217 4.67459C10.9641 4.30288 10.2213 4.37637 9.74728 4.85038L4.44403 10.1537C3.96994 10.6277 3.89644 11.3704 4.26834 11.9281L6.24769 14.8971C5.61909 16.069 5.10891 17.3012 4.72378 18.5774L1.22419 19.2773C0.566906 19.4087 0.09375 19.9859 0.09375 20.6562V28.1562C0.09375 28.8266 0.566906 29.4038 1.22428 29.5351L4.72388 30.2351C5.10891 31.5112 5.61919 32.7434 6.24778 33.9153L4.26844 36.8844C3.89653 37.4421 3.97012 38.1848 4.44413 38.6588L9.74738 43.962C10.2215 44.4361 10.9641 44.5096 11.5218 44.1378L14.4301 42.1991V33.3711C12.2277 31.0269 10.875 27.8773 10.875 24.4062C10.875 17.1575 16.7512 11.2812 24 11.2812C31.2488 11.2812 37.125 17.1575 37.125 24.4062C37.125 27.8773 35.7723 31.0269 33.5699 33.3711V42.1991L36.4782 44.1378C36.7162 44.2964 36.9877 44.3741 37.2577 44.3741C37.6207 44.3741 37.9808 44.2339 38.2525 43.9621L43.5558 38.6589C44.0298 38.1849 44.1034 37.4422 43.7315 36.8845L41.7521 33.9154C42.3807 32.7435 42.8909 31.5113 43.276 30.2352L46.7756 29.5352C47.4331 29.4038 47.9062 28.8266 47.9062 28.1562V20.6562C47.9062 19.9859 47.4331 19.4087 46.7757 19.2773Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.4549 16.701C27.7472 16.291 26.8492 16.726 26.7323 17.5355L25.875 23.4687H22.125L21.2678 17.5355C21.1508 16.726 20.2529 16.291 19.5452 16.701C16.7993 18.2915 15.0938 21.244 15.0938 24.4062C15.0938 27.833 17.0128 30.8984 20.102 32.4062L20.25 32.4785V47.0937C20.25 47.8703 20.8796 48.5 21.6562 48.5H26.3438C27.1204 48.5 27.75 47.8703 27.75 47.0937V32.4785L27.898 32.4062C30.9872 30.8984 32.9062 27.833 32.9062 24.4062C32.9062 21.244 31.2007 18.2915 28.4549 16.701Z",
    fill: "#0e131c"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2938_1047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdSerIcon01);
export default __webpack_public_path__ + "static/media/cd-ser_icon01.f734104c6e4c3f66e9eb958218e572de.svg";
export { ForwardRef as ReactComponent };